import { Button } from "@/components/ui/Button";
import * as shared from "@/styles/shared";
import type { ScrapingHeaderProps } from "@shared/types/scraping";
import { ChevronLeft, MonitorPlay, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import * as styles from "./ScrapingHeader.styles";

const ScrapingHeader = ({ onBack, onClearLogs, hasLogs }: ScrapingHeaderProps) => {
  const { t } = useTranslation("scraping");
  return (
    <div className={shared.stickyHeader}>
      <div className={shared.rowGap3}>
        <Button variant="ghost" size="sm" onClick={onBack} className={styles.backBtn}>
          <ChevronLeft className="h-4 w-4" />
          {t("back")}
        </Button>
        <div className={shared.rowGap2}>
          <MonitorPlay className={styles.titleIcon} />
          <h1 className={styles.headerTitle}>{t("title")}</h1>
        </div>
      </div>
      {hasLogs && (
        <Button variant="ghost" size="sm" onClick={onClearLogs} className={styles.clearBtn}>
          <X className="h-4 w-4" />
          {t("clearLogs")}
        </Button>
      )}
    </div>
  );
};

export { ScrapingHeader };
